export function operacaoBloqueioVeiculoPreFaturaGeradaInRequest(params = {}) {
  return {
    type: '@operacaobloqueioveiculoprefaturagerada/RADAPROVARPREFATURA_IN_REQUEST',
    payload: { params },
  };
}

export function veiculosBloqueadosPreFaturaGeradaInRequest(params = {}) {
  return {
    type: '@veiculosbloqueadosprefaturageradainrequest/RADAPROVARPREFATURA_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoBloqueioVeiculoPreFaturaGerada(fatu_codigo) {
  return {
    type: '@operacaobloqueioveiculoprefaturagerada/FIND_RADAPROVARPREFATURA',
    payload: { fatu_codigo },
  };
}

export function findVeiculosBloqueadosPreFaturaGerada(fatu_codigo) {
  return {
    type: '@operacaobloqueioveiculoprefaturagerada/FIND_VEICULOSPREGERADA',
    payload: { fatu_codigo },
  };
}

export function failedRequest() {
  return {
    type: '@operacaobloqueioveiculoprefaturagerada/FAILED_REQUEST',
  };
}

export function deleteOperacaoBloqueioVeiculoPreFaturaGerada(fatu_codigo, params) {
  return {
    type: '@operacaobloqueioveiculoprefaturagerada/DELETE_RADAPROVARPREFATURA',
    payload: { fatu_codigo, params },
  };
}

export function updateOperacaoBloqueioVeiculoPreFaturaGerada(
  operacaobloqueioveiculoprefaturagerada,
  params
) {
  return {
    type: '@operacaobloqueioveiculoprefaturagerada/UPDATE_RADAPROVARPREFATURA',
    payload: { operacaobloqueioveiculoprefaturagerada, params },
  };
}

export function storeOperacaoBloqueioVeiculoPreFaturaGerada(
  operacaobloqueioveiculoprefaturagerada,
  params
) {
  return {
    type: '@operacaobloqueioveiculoprefaturagerada/STORE_RADAPROVARPREFATURA',
    payload: { operacaobloqueioveiculoprefaturagerada, params },
  };
}

export function successInRequest(
  operacaobloqueioveiculoprefaturagerada,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaobloqueioveiculoprefaturagerada/SUCCESS_IN_REQUEST',
    payload: {
      operacaobloqueioveiculoprefaturagerada,
      page,
      pageSize,
      totalCount,
      totalPages,
    },
  };
}

export function successRequest(operacaobloqueioveiculoprefaturagerada) {
  return {
    type: '@operacaobloqueioveiculoprefaturagerada/SUCCESS_REQUEST',
    payload: { operacaobloqueioveiculoprefaturagerada },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaobloqueioveiculoprefaturagerada/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaobloqueioveiculoprefaturagerada/RECORD_FILTERING',
    payload: { params },
  };
}

export function recordFilteringVeiculo(params) {
  return {
    type: '@operacaobloqueioveiculoprefaturagerada/RECORD_FILTERING_VEICULO',
    payload: { params },
  };
}
